import { render, staticRenderFns } from "./Compras.vue?vue&type=template&id=e7671ec4"
import script from "./Compras.vue?vue&type=script&lang=js"
export * from "./Compras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports